/**
 * Los colores de la entrada a la caja con PIN, cada uno con su par `dark:`.
 *
 * El login dibuja una tarjeta oscura dentro del tema claro: un `dark` anidado.
 * Ahí los tokens (`text-text-primary`, `text-primary`, `border-input`…) siguen
 * valiendo lo del tema claro, porque `@theme` los resuelve en `:root` y los
 * hijos los heredan ya resueltos; poner `.dark` en un contenedor cambia
 * `--text-primary`, pero no el `--color-text-primary` que heredan sus hijos. Lo
 * único que ve el `.dark` de un ancestro es la variante `dark:`. Por eso cada
 * color que sale de un token lleva su par explícito, con el valor que el tema
 * oscuro le da a ese token (el `Button` hace lo mismo): sin él, el título y lo
 * que se teclea quedan casi negros sobre la tarjeta (1,1:1; se necesita 4,5:1).
 *
 * Con el tema oscuro de toda la app, los pares dan lo mismo que los tokens.
 */

/** El texto de la sección: lo heredan el título, la etiqueta y el campo. */
export const TEXTO = "text-text-primary dark:text-slate-50";

export const TEXTO_SECUNDARIO = "text-text-secondary dark:text-slate-400";

export const TEXTO_DE_ERROR = "text-error-foreground dark:text-red-300";

/** El borde y el anillo de foco del campo del PIN. */
export const CAMPO = "dark:border-slate-700 dark:focus-visible:ring-slate-400";

/** «Volver», un `Button` con la variante `link`. */
export const ENLACE = "self-start px-0 dark:text-slate-50";

/** «Elegir otro cajero», un `Button` con la variante `ghost`. */
export const BOTON_SUAVE =
  "dark:text-slate-50 dark:hover:bg-slate-800 dark:hover:text-slate-50";
